module.exports = __webpack_public_path__ + "img/empty.1ad4337b.svg";